import dynamic from "next/dynamic";

export const IR35FAQs = dynamic(() => import("./component"));
